import Butter from 'buttercms';

const butter = Butter('84f7afe3f05363a9b5dfa868f0ce003249d63c45');

export default butter;
